(function () {
  var rotators = document.querySelectorAll('[data-cq-rotator]');
  if (!rotators.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  rotators.forEach(function (rotator) {
    if (rotator.dataset.tplCqBound === '1') return;
    rotator.dataset.tplCqBound = '1';
    var items = Array.prototype.slice.call(rotator.querySelectorAll('.tpl-cq__provocation'));
    if (items.length < 1) return;

    /* Random starting index — returning visitors see fresh copy each visit. */
    var idx = Math.floor(Math.random() * items.length);
    items[idx].classList.add('is-active');

    if (items.length < 2 || reduced) return;
    var interval = Math.max(3000, parseInt(rotator.dataset.interval || '5500', 10));
    var paused = false;
    document.addEventListener('visibilitychange', function () { paused = document.hidden; });

    /* Crossfade logic: outgoing gets is-leaving (drifts up + blurs out),
       incoming starts ~250ms later (overlap). Both finish around the
       same time. Total transition feels like ~1.1s of motion.            */
    var OVERLAP_MS = 250;
    var LEAVE_MS = 800;
    function rotate() {
      if (paused) return;
      var current = items[idx];
      var nextIdx = (idx + 1) % items.length;
      var next = items[nextIdx];

      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      setTimeout(function () {
        current.classList.remove('is-leaving');
      }, LEAVE_MS);

      setTimeout(function () {
        next.classList.add('is-active');
      }, OVERLAP_MS);

      idx = nextIdx;
    }
    var timer = setInterval(rotate, interval);
    // Stop the timer when the section is removed (theme-editor reorder) or the tab
    // is hidden, so it never leaks or runs work the shopper can't see.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { clearInterval(timer); timer = null; }
      else if (!timer) { timer = setInterval(rotate, interval); }
    });
  });
})();
